module.exports = __webpack_public_path__ + "img/question.97e68c3b.svg";